import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTACT_EMAIL = "ms.signaturepro@outlook.com";

const articles = [
  {
    title: "Identité du Vendeur",
    paragraphs: [
      "Le site internet https://mssignature.fr est exploité par :",
    ],
    list: [
      "Exploitante : Marwa-Alya Tiba",
      "Nom d'usage : Bezazel",
      "Nom commercial déclaré : Whiteglow",
      "Nom de la boutique : MS Signature",
      "Forme juridique : Entreprise individuelle",
      "SIREN : 941 482 978",
      "SIRET : 941 482 978 00017",
      "Immatriculation : RCS de Mulhouse",
      "Adresse de l'établissement : 34 rue de l'Île Napoléon, 68100 Mulhouse, France",
      "Adresse e-mail : ms.signaturepro@outlook.com",
      "Site internet : https://mssignature.fr",
    ],
    after: "Ci-après désignée « MS Signature » ou « le Vendeur ».",
  },
  {
    title: "Objet et champ d'application",
    paragraphs: [
      "Les présentes Conditions Générales de Vente définissent les droits et obligations de MS Signature et de ses clients dans le cadre de la vente de produits proposés sur le site internet mssignature.fr.",
      "MS Signature est spécialisée dans la confection, la personnalisation et la commercialisation de panneaux personnalisés, notamment :",
    ],
    list: [
      "Panneaux de bienvenue.",
      "Panneaux personnalisés pour mariages.",
      "Panneaux pour anniversaires et événements.",
      "Signalétique événementielle.",
      "Panneaux décoratifs personnalisés.",
      "Créations sur mesure selon les demandes des clients.",
    ],
    after: "Les présentes CGV s'appliquent à toutes les commandes effectuées sur la boutique en ligne. Toute commande passée sur le site implique la prise de connaissance et l'acceptation des présentes Conditions Générales de Vente.",
  },
  {
    title: "Produits",
    paragraphs: [
      "Les produits proposés à la vente sont présentés sur le site avec leurs caractéristiques essentielles, leurs dimensions, leurs matériaux, leurs options de personnalisation et leurs prix.",
      "MS Signature s'efforce de présenter les produits de manière aussi fidèle que possible. Toutefois, de légères différences de couleurs ou de rendu peuvent exister entre les photographies présentées sur le site et le produit final, notamment en raison des réglages d'écran et des caractéristiques des matériaux utilisés.",
      "Les produits personnalisés sont réalisés selon les choix et indications communiqués par le client lors de sa commande.",
    ],
  },
  {
    title: "Commandes",
    paragraphs: [
      "Les commandes sont effectuées directement sur le site mssignature.fr. Pour passer commande, le client doit :",
    ],
    list: [
      "Sélectionner le produit souhaité.",
      "Choisir les options de personnalisation disponibles.",
      "Renseigner les informations nécessaires à la réalisation du produit.",
      "Vérifier le contenu de son panier.",
      "Renseigner ses coordonnées de livraison et de facturation.",
      "Choisir son moyen de paiement.",
      "Valider sa commande après avoir pris connaissance des présentes CGV.",
    ],
    after: "La validation définitive de la commande entraîne une obligation de paiement. Une confirmation de commande est adressée au client par courrier électronique. MS Signature se réserve le droit de contacter le client lorsque certaines informations nécessaires à la fabrication du produit sont manquantes ou nécessitent une clarification. En cas d'impossibilité de réaliser une commande, le client sera informé et les sommes versées seront remboursées dans les conditions légales applicables.",
  },
  {
    title: "Personnalisation des produits",
    paragraphs: [
      "Les produits proposés par MS Signature peuvent être personnalisés selon les choix et indications du client.",
      "Le client est responsable de l'exactitude des informations transmises pour la personnalisation, notamment :",
    ],
    list: [
      "Les prénoms et noms.",
      "Les dates.",
      "Les textes et inscriptions.",
      "Les couleurs et options choisies.",
      "Les éventuelles photographies ou illustrations transmises.",
    ],
    after: "Le client doit vérifier attentivement les informations communiquées avant de confirmer sa commande. Une fois la fabrication commencée, aucune modification ne pourra être garantie. MS Signature ne pourra être tenue responsable des erreurs résultant d'informations incorrectes fournies par le client, lorsque le produit a été réalisé conformément aux informations transmises. Cette disposition ne limite pas les droits légaux du consommateur.",
  },
  {
    title: "Prix et modalités de paiement",
    paragraphs: [
      "Les prix des produits sont indiqués en euros sur le site mssignature.fr. Le prix applicable est celui affiché au moment de la validation de la commande.",
      "Les éventuels frais de livraison sont indiqués avant la confirmation définitive de la commande. Le montant total à régler est communiqué au client avant le paiement.",
      "Le paiement est exigible en totalité au moment de la commande, sauf indication contraire. Les paiements sont effectués en ligne par les moyens proposés sur la boutique, notamment par carte bancaire via Shopify Payments. Les transactions sont sécurisées par les prestataires de paiement concernés. MS Signature ne conserve pas directement les numéros complets des cartes bancaires de ses clients.",
      "La commande est considérée comme définitive après confirmation du paiement. En cas de refus de paiement par l'établissement bancaire ou le prestataire de paiement, la commande pourra être suspendue ou annulée.",
    ],
  },
  {
    title: "Fabrication et délais de réalisation",
    paragraphs: [
      "Les produits personnalisés sont fabriqués après validation et paiement de la commande. Les délais de fabrication peuvent varier selon :",
    ],
    list: [
      "Le type de panneau commandé.",
      "Le niveau de personnalisation demandé.",
      "Le volume des commandes en cours.",
      "La disponibilité des matériaux nécessaires.",
    ],
    after: "Le délai estimé de fabrication et d'expédition est indiqué sur la fiche produit ou communiqué au client avant la validation de sa commande. Les délais de fabrication sont distincts des délais de livraison. En cas de retard exceptionnel, MS Signature informera le client dans les meilleurs délais. À défaut de date ou de délai de livraison indiqué, les règles légales relatives au délai maximal de livraison s'appliquent. En cas de défaut de livraison dans les conditions prévues par la loi, le client pourra demander la résolution du contrat et obtenir le remboursement des sommes versées conformément aux dispositions du Code de la consommation.",
  },
  {
    title: "Livraison",
    paragraphs: [
      "Les produits sont expédiés à l'adresse communiquée par le client lors de la commande. Les zones de livraison proposées ainsi que les frais applicables sont indiqués sur la boutique en ligne.",
      "Le client est responsable de l'exactitude des coordonnées de livraison renseignées. En cas d'erreur dans l'adresse communiquée par le client, celui-ci est invité à contacter rapidement MS Signature.",
      `À réception du colis, le client est invité à vérifier l'état de son produit. En cas de colis endommagé ou de produit détérioré pendant le transport, le client peut contacter MS Signature à l'adresse suivante : ${CONTACT_EMAIL}. Des photographies pourront être demandées afin de faciliter le traitement de la réclamation.`,
      "Le transfert des risques intervient conformément aux dispositions légales applicables aux consommateurs.",
    ],
  },
  {
    title: "Droit de rétractation",
    paragraphs: [
      "Conformément aux articles L221-18 et suivants du Code de la consommation, le consommateur dispose en principe d'un délai de quatorze (14) jours à compter de la réception du produit pour exercer son droit de rétractation lors d'un achat à distance.",
      "Exception concernant les produits personnalisés : conformément à l'article L221-28, 3° du Code de la consommation, le droit de rétractation ne s'applique pas aux biens confectionnés selon les spécifications du consommateur ou nettement personnalisés.",
      "Ainsi, les panneaux réalisés sur mesure ou personnalisés selon les demandes spécifiques du client ne peuvent pas faire l'objet d'un retour ou d'un remboursement au titre d'un simple changement d'avis. Cette exclusion concerne notamment les panneaux comportant des prénoms, des dates, des inscriptions ou des compositions graphiques spécialement demandées par le client.",
      "Pour les produits standards non personnalisés, le droit légal de rétractation de quatorze jours reste applicable.",
      `Le client souhaitant exercer son droit de rétractation doit informer MS Signature de sa décision avant l'expiration du délai légal, par courrier électronique à l'adresse suivante : ${CONTACT_EMAIL}.`,
      "Les produits concernés doivent être retournés dans les conditions légales applicables. Les frais de retour sont à la charge du client, sauf disposition légale contraire. Le remboursement intervient dans les délais prévus par la loi.",
      "L'exclusion du droit de rétractation pour les produits personnalisés ne prive en aucun cas le client de ses droits concernant les garanties légales de conformité et les vices cachés.",
    ],
  },
  {
    title: "Annulation et modification des commandes",
    paragraphs: [
      `Toute demande d'annulation ou de modification doit être adressée rapidement à MS Signature par courrier électronique à l'adresse : ${CONTACT_EMAIL}.`,
      "Lorsqu'une commande personnalisée n'a pas encore été mise en fabrication, MS Signature pourra étudier la possibilité de la modifier ou de l'annuler.",
      "Lorsque la fabrication personnalisée a commencé ou que le produit a été confectionné selon les spécifications du client, l'annulation pour simple changement d'avis ne donne pas droit à un remboursement au titre du droit de rétractation, sous réserve des droits légaux applicables.",
      "En cas de défaut de conformité ou de manquement du vendeur à ses obligations, les droits légaux du client restent intégralement applicables.",
    ],
  },
  {
    title: "Garanties légales",
    paragraphs: [
      "Tous les produits vendus par MS Signature bénéficient des garanties légales prévues par la législation française.",
      "Garantie légale de conformité : conformément aux articles L217-3 et suivants du Code de la consommation, le client bénéficie de la garantie légale de conformité pendant une durée de deux ans à compter de la délivrance du bien. En cas de défaut de conformité, le client peut demander la mise en conformité du produit par réparation ou remplacement dans les conditions prévues par la loi. À défaut, il peut bénéficier d'une réduction du prix ou de la résolution du contrat lorsque les conditions légales sont réunies.",
      "Garantie contre les vices cachés : conformément aux articles 1641 et suivants du Code civil, le client bénéficie également de la garantie contre les vices cachés. Cette garantie permet au client de demander le remboursement ou une réduction du prix du produit lorsque les conditions légales sont réunies.",
      "Les garanties légales s'appliquent également aux produits personnalisés.",
    ],
  },
  {
    title: "Réclamations et service client",
    paragraphs: [
      "La responsable de la boutique MS Signature est Marwa-Alya Tiba.",
      `Pour toute question, demande d'information ou réclamation concernant une commande, le client peut contacter directement la responsable à l'adresse suivante : ${CONTACT_EMAIL}.`,
      "Toute réclamation devra, dans la mesure du possible, préciser le numéro de commande et être accompagnée des éléments permettant d'identifier le problème rencontré. Des photographies pourront être demandées pour faciliter le traitement de la demande.",
      "Marwa-Alya Tiba s'engage à examiner chaque réclamation dans les meilleurs délais.",
    ],
  },
  {
    title: "Médiation de la consommation",
    paragraphs: [
      "Conformément aux articles L612-1 et suivants du Code de la consommation, le client consommateur a la possibilité de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d'un litige avec MS Signature.",
      `Le client devra au préalable avoir adressé une réclamation écrite à la responsable de la boutique, Marwa-Alya Tiba, à l'adresse suivante : ${CONTACT_EMAIL}.`,
      "En l'absence de solution satisfaisante, le consommateur pourra saisir le médiateur de la consommation auquel MS Signature aura adhéré.",
      "Le médiateur est un organisme indépendant de l'entreprise. Il ne peut pas s'agir de Marwa-Alya Tiba, qui est la responsable et l'exploitante de MS Signature.",
      "Coordonnées du médiateur de la consommation : à compléter avant la publication définitive des présentes CGV.",
    ],
  },
  {
    title: "Responsabilité",
    paragraphs: [
      "MS Signature s'engage à apporter le soin nécessaire à la préparation, à la personnalisation et à l'expédition des commandes.",
      "La responsabilité de MS Signature ne saurait être engagée en cas de mauvaise utilisation du produit par le client, de détérioration résultant d'une utilisation non conforme ou d'informations erronées transmises par le client pour la personnalisation.",
      "La responsabilité de MS Signature ne pourra être engagée en cas de force majeure au sens de l'article 1218 du Code civil, dans les limites prévues par la législation applicable.",
      "Aucune disposition des présentes CGV ne saurait limiter les droits légaux du consommateur.",
    ],
  },
  {
    title: "Propriété intellectuelle",
    paragraphs: [
      "L'ensemble des éléments présents sur le site mssignature.fr, notamment les photographies, créations graphiques, illustrations, textes, logos, visuels et éléments de présentation, sont protégés par les dispositions relatives à la propriété intellectuelle.",
      "Toute reproduction, représentation, modification ou utilisation sans autorisation préalable est interdite.",
      "Le client garantit disposer des droits ou autorisations nécessaires sur les photographies, textes, logos et éléments qu'il transmet pour la réalisation de sa commande.",
    ],
  },
  {
    title: "Données personnelles",
    paragraphs: [
      "Dans le cadre des commandes, MS Signature collecte certaines données personnelles nécessaires au traitement des achats, au paiement, à la fabrication des produits personnalisés, à la livraison et au service client.",
      "Ces données peuvent notamment comprendre :",
    ],
    list: [
      "Nom et prénom.",
      "Adresse postale.",
      "Adresse électronique.",
      "Numéro de téléphone.",
      "Informations relatives à la commande.",
      "Informations nécessaires à la personnalisation.",
    ],
    after: `Les données bancaires sont traitées par les prestataires de paiement sécurisés. Les données personnelles sont traitées conformément à la réglementation applicable, notamment au Règlement général sur la protection des données (RGPD). Le client dispose des droits d'accès, de rectification, d'effacement, de limitation et d'opposition dans les conditions prévues par la réglementation. Pour exercer ses droits, le client peut contacter : ${CONTACT_EMAIL}. Une politique de confidentialité distincte est également accessible sur le site mssignature.fr.`,
  },
  {
    title: "Force majeure",
    paragraphs: [
      "MS Signature ne pourra être tenue responsable d'un retard ou d'une inexécution de ses obligations résultant d'un événement de force majeure au sens de l'article 1218 du Code civil.",
      "En cas de survenance d'un tel événement, le client sera informé dans les meilleurs délais. Les droits légaux du consommateur demeurent applicables.",
    ],
  },
  {
    title: "Droit applicable et litiges",
    paragraphs: [
      "Les présentes Conditions Générales de Vente sont soumises au droit français.",
      "En cas de différend, le client est invité à contacter MS Signature afin de rechercher une solution amiable.",
      "À défaut de résolution amiable, le litige pourra être porté devant les juridictions compétentes conformément aux règles légales applicables.",
    ],
  },
  {
    title: "Acceptation des Conditions Générales de Vente",
    paragraphs: [
      "Le client reconnaît avoir pris connaissance des présentes Conditions Générales de Vente avant de procéder à sa commande. La validation de la commande implique l'acceptation des présentes conditions.",
      "Les CGV applicables sont celles en vigueur à la date de validation de la commande.",
      "MS Signature se réserve le droit de modifier ses Conditions Générales de Vente à tout moment. Les modifications ne s'appliqueront pas aux commandes déjà validées.",
    ],
  },
];

export default function Terms() {
  return (
    <main className="max-w-4xl mx-auto px-6 lg:px-10 py-12 sm:py-20" data-testid="terms-page">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#7B5338] hover:underline underline-offset-4" data-testid="terms-home-link"><ArrowLeft size={16} /> Retour à l’accueil</Link>
      <header className="mt-10 pb-10 border-b border-[#CDC0B0]">
        <p className="label-xs">MS SIGNATURE — mssignature.fr</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-4 text-[#3A322B] leading-tight" data-testid="terms-title">Conditions générales de vente</h1>
        <p className="mt-6 text-sm text-[#6B5F53]"><strong>Date de dernière mise à jour :</strong> <time dateTime="2026-10-30">30 octobre 2026</time></p>
      </header>
      <div className="divide-y divide-[#DDD3C6]">
        {articles.map((article, index) => (
          <section key={article.title} aria-labelledby={`terms-heading-${index + 1}`} className="py-8 sm:py-10" data-testid={`terms-article-${index + 1}`}>
            <h2 id={`terms-heading-${index + 1}`} className="text-base md:text-lg font-semibold text-[#3A322B] uppercase tracking-wide mb-5">Article {index + 1} — {article.title}</h2>
            <div className="space-y-4 text-sm sm:text-base leading-relaxed text-[#6B5F53] [overflow-wrap:anywhere]">
              {article.paragraphs.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
              {article.list && <ul className="list-disc pl-6 space-y-2">{article.list.map((item) => <li key={item}>{item}</li>)}</ul>}
              {article.after && <p>{article.after}</p>}
            </div>
          </section>
        ))}
      </div>
      <footer className="mt-12 pt-8 border-t border-[#CDC0B0] text-sm text-[#6B5F53] space-y-1" data-testid="terms-footer">
        <p className="font-semibold text-[#3A322B]">MS SIGNATURE — mssignature.fr</p>
        <p>Exploitante : Marwa-Alya Tiba</p>
        <p>Nom commercial déclaré : Whiteglow</p>
        <p>Entreprise individuelle</p>
        <p>SIREN : 941 482 978 — SIRET : 941 482 978 00017</p>
        <p>RCS Mulhouse</p>
        <p>Adresse : 34 rue de l'Île Napoléon, 68100 Mulhouse, France</p>
        <p>E-mail : <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#7B5338] underline underline-offset-4">{CONTACT_EMAIL}</a></p>
      </footer>
    </main>
  );
}
